import styles from './Main.module.scss';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

export default function CookiePolicyMain({ fields }) {
  console.info(fields, 'CookiePolicyMain fields');
  return (
    <div className={styles.main}>
      <div className="container">
        <div className={styles.inner}>
          <RichText field={fields.content}></RichText>

          <div id="cookiefirst-policy-page"></div>
          <div>
            This cookie policy has been created and updated by{' '}
            <a href="https://cookiefirst.com/consent-management-platform/">
              Consent Management Platform
            </a>
            .
          </div>

          <div id="cookiefirst-cookies-table"></div>
          <div>
            This cookie table has been created and updated by the{' '}
            <a href="https://cookiefirst.com/consent-management-platform/">
              Consent Management - CookieFirst
            </a>
            .
          </div>
        </div>
      </div>
    </div>
  );
}
